import { c as _c } from "react/compiler-runtime";
import { Pagination, type PaginationLabels } from "../Pagination/Pagination";
export interface TablePaginationFooterProps {
  totalPages?: number;
  pageIndex?: number;
  totalItems?: number;
  perPage?: number;
  onChange: (page: number) => void; // receives 1-based page
  /** Override labels for i18n support. Passed through to the Pagination component. */
  paginationLabels?: PaginationLabels;
}
export function TablePaginationFooter(t0) {
  const $ = _c(8);
  const {
    totalPages,
    pageIndex,
    totalItems,
    perPage,
    onChange,
    paginationLabels
  } = t0;
  const total = Math.max(1, totalPages || 0);
  const currentPage = Math.min(Math.max(1, (pageIndex ?? 0) + 1), total);
  const t1 = !!totalItems;
  let t2;
  if ($[0] !== currentPage || $[1] !== onChange || $[2] !== paginationLabels || $[3] !== perPage || $[4] !== t1 || $[5] !== total || $[6] !== totalItems) {
    t2 = <div className="w-full"><Pagination total={total} page={currentPage} onChange={onChange} showControls={true} showResultsCounter={t1} totalItems={totalItems} perPage={perPage} labels={paginationLabels} /></div>;
    $[0] = currentPage;
    $[1] = onChange;
    $[2] = paginationLabels;
    $[3] = perPage;
    $[4] = t1;
    $[5] = total;
    $[6] = totalItems;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}